import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconSupport = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.6789 3.60992L4.34807 6.2791M3.60993 1.67889L6.2791 4.34806M11.3901 1.67889L8.7209 4.34806M13.3211 3.60992L10.6519 6.2791M13.3211 11.3901L10.6519 8.72089M11.3901 13.3211L8.7209 10.6519M3.60993 13.3211L6.2791 10.6519M1.6789 11.3901L4.34807 8.72089M14.5 7.5C14.5 11.366 11.366 14.5 7.5 14.5C3.63401 14.5 0.5 11.366 0.5 7.5C0.5 3.63401 3.63401 0.5 7.5 0.5C11.366 0.5 14.5 3.63401 14.5 7.5ZM10.8793 7.5C10.8793 9.36634 9.36634 10.8793 7.5 10.8793C5.63366 10.8793 4.12069 9.36634 4.12069 7.5C4.12069 5.63366 5.63366 4.12069 7.5 4.12069C9.36634 4.12069 10.8793 5.63366 10.8793 7.5Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgIconSupport;
